import script from "./SettlementDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SettlementDetail.vue?vue&type=script&setup=true&lang=js"

import "./SettlementDetail.vue?vue&type=style&index=0&id=0da239cd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da239cd"]])

export default __exports__